import * as Sentry from "@sentry/react";
import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import { unregister } from './registerServiceWorker';

Sentry.init({
  dsn: "https://238b90823abf8cbc69deb197b09c88c9@o4510440439283712.ingest.de.sentry.io/4510440595849296",
  environment: process.env.NODE_ENV,
});

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
    rootElement);

unregister();

//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js